(function() {
    'use strict';

    var host = (window.location.hostname || '').toLowerCase();
    var isLocal = host === 'localhost' || host === '127.0.0.1' || host.endsWith('.local');

    angular
        .module('elogbooks')
        .constant(
            'API_URL',
            (function () {
                // Local environments typically proxy API on the same host under /api.
                // Using <installation>-api.<domain> breaks if DNS isn't configured (ERR_NAME_NOT_RESOLVED spam).
                if (isLocal) {
                    return window.location.protocol + '//' + window.location.hostname + '/api';
                }

                var dot = window.location.hostname.indexOf('.');
                var installation = dot > 0 ? window.location.hostname.substring(0, dot) : window.location.hostname;
                var domain = dot > 0 ? window.location.hostname.substring(dot + 1) : window.location.hostname;

                return window.location.protocol + '//' + installation + '-api.' + domain;
            })()
        );
})();
